/* eslint no-multiple-empty-lines: 0 */
export const heater = 'heater';

const branchIndustrial = 'branch-industrial';
const stepGoalTemp = 'goal-temp';
const stepFlowRate = 'flow-rate';
const stepResult = 'result';
const is3PhasePower = 'is-3-phase-power';
// const hasMixingValve = 'has-mixing-valve';
const stepVoltage = 'voltage';

export default [
  {
    id: `${branchIndustrial}_requirements`,
    step: 'Requirements',
    component: 'Selector',
    title: 'Does your application require...',
    options: [
      {
        title: 'Compatibility with deionized (DI) or reverse osmosis (RO) water?',
        value: '1',
        params: { application: ['deionized'] },
        nextId: `${branchIndustrial}_do/ro_${is3PhasePower}`,
      },
      {
        title: 'Temperatures of 180°F for washdown use?',
        value: '2',
        nextId: `${branchIndustrial}_t180_${is3PhasePower}`,
      },
      {
        title: 'Hot water needs between 100°F – 140°F',
        value: '3',
        params: { 'max-temp': 140, 'min-temp': 100 },
        nextId: `${branchIndustrial}_t100-140_${is3PhasePower}`,
      },
    ],
  },
  // branch Industrial - do/ro
  {
    id: `${branchIndustrial}_do/ro_${is3PhasePower}`,
    step: '3-phase power',
    component: 'Selector',
    title: 'Is 3-phase power going to be used?',
    tip: '<b>Note</b>: For higher GPM flow rates (+4 GPM), you will likely need 3-Phase power to facilitate the higher kW necessary to achieve higher temperatures!!',
    options: [
      {
        title: 'Yes',
        value: '1',
        nextId: `${branchIndustrial}_do/ro_3phase_${stepVoltage}`,
        typeYes: true,
        params: { phase: 3 },
      },
      {
        title: 'No',
        value: '0',
        nextId: `${branchIndustrial}_do/ro_1phase_${stepVoltage}`,
        typeNo: true,
        params: { phase: 1 },
      },
    ],
  },
  // branch Industrial - do/ro - 3 phase
  {
    id: `${branchIndustrial}_do/ro_3phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of 3-Phase voltage for your heater?',
    options: [
      { title: '208 V', value: 208, nextId: `${branchIndustrial}_do/ro_3phase_208/480V_${stepFlowRate}` },
      { title: '480 V', value: 480, nextId: `${branchIndustrial}_do/ro_3phase_208/480V_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  // branch Industrial - do/ro - 3 phase - 208V / 480V
  {
    id: `${branchIndustrial}_do/ro_3phase_208/480V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures that will be serviced should be for the total volume that would be running simultaneously and not the amount of fixtures.',
    defaultValue: 3,
    inputLabel: 'Enter Total Flow Rate (GPM)',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.7 GPM & 4 GPM. If higher than 4 GPM, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select that flow rate.',
    img: `${process.env.VUE_APP_PATH}img/fr1.jpg`,
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_do/ro_3phase_208/480V_${stepGoalTemp}`,
  },
  {
    id: `${branchIndustrial}_do/ro_3phase_208/480V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues standard Deionized type water heaters set at 120°F, which can be field-adjusted up to 140°F & down to 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    tip: '<b>Note</b>: Eemax does not manufacture Deionized type water heaters that will go beyond 140°F up to 180°F!',
    defaultValue: 120,
    locked: false,
    nextId: `${branchIndustrial}_do/ro_3phase_208/480V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_do/ro_3phase_208/480V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - do/ro - 1 phase
  {
    id: `${branchIndustrial}_do/ro_1phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    options: [
      { title: '120 V', value: 120, nextId: `${branchIndustrial}_do/ro_1phase_120V_${stepFlowRate}` },
      { title: '208 V', value: 208, nextId: `${branchIndustrial}_do/ro_1phase_208V_${stepFlowRate}` },
      { title: '240 V', value: 240, nextId: `${branchIndustrial}_do/ro_1phase_240V_${stepFlowRate}` },
      { title: '277 V', value: 277, nextId: `${branchIndustrial}_do/ro_1phase_277V_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  // branch Industrial - do/ro - 1 phase - 120V
  {
    id: `${branchIndustrial}_do/ro_1phase_120V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures that will be serviced should be for the total volume that would be running simultaneously and not the amount of fixtures.',
    defaultValue: 0.5,
    inputLabel: 'Enter Total Flow Rate (GPM)',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 to 2 GPM. If higher than 2 GPM, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select that flow rate.',
    img: `${process.env.VUE_APP_PATH}img/fr1.jpg`,
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_do/ro_1phase_120V_${stepGoalTemp}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_120V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues standard Deionized type water heaters set at 120°F, which can be field-adjusted up to 140°F & down to 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    tip: '<b>Note</b>: Eemax does not manufacture Deionized type water heaters that will go beyond 140°F up to 180°F!',
    defaultValue: 120,
    locked: false,
    nextId: `${branchIndustrial}_do/ro_1phase_120V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_120V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - do/ro - 1 phase - 208V
  {
    id: `${branchIndustrial}_do/ro_1phase_208V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures that will be serviced should be for the total volume that would be running simultaneously and not the amount of fixtures.',
    defaultValue: 2,
    inputLabel: 'Enter Total Flow Rate (GPM)',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 to 2 GPM (LavAdvantage), or 0.7 to 3 GPM (Series 2). If higher than those respective max flows, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select that flow rate.',
    img: `${process.env.VUE_APP_PATH}img/fr1.jpg`,
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_do/ro_1phase_208V_${stepGoalTemp}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_208V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues standard Deionized type water heaters set at 120°F, which can be field-adjusted up to 140°F & down to 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    tip: '<b>Note</b>: Eemax does not manufacture Deionized type water heaters that will go beyond 140°F up to 180°F!',
    defaultValue: 120,
    locked: false,
    nextId: `${branchIndustrial}_do/ro_1phase_208V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_208V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - do/ro - 1 phase - 240V
  {
    id: `${branchIndustrial}_do/ro_1phase_240V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures that will be serviced should be for the total volume that would be running simultaneously and not the amount of fixtures.',
    defaultValue: 3.5,
    inputLabel: 'Enter Total Flow Rate (GPM)',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 to 2 GPM (LavAdvantage) or 0.7 to 4 GPM (Series 2 or 3). If higher than 4 GPM, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select that flow rate.',
    img: `${process.env.VUE_APP_PATH}img/fr1.jpg`,
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_do/ro_1phase_240V_${stepGoalTemp}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_240V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues standard Deionized type water heaters set at 120°F, which can be field-adjusted up to 140°F & down to 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    tip: '<b>Note</b>: Eemax does not manufacture Deionized type water heaters that will go beyond 140°F up to 180°F!',
    defaultValue: 120,
    locked: false,
    nextId: `${branchIndustrial}_do/ro_1phase_240V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_240V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - do/ro - 1 phase - 277V
  {
    id: `${branchIndustrial}_do/ro_1phase_277V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures that will be serviced should be for the total volume that would be running simultaneously and not the amount of fixtures.',
    defaultValue: 3,
    inputLabel: 'Enter Total Flow Rate (GPM)',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 to 2 GPM (LavAdvantage), or 0.7 to 3 GPM (Series 2). If higher than those respective max flows, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select that flow rate.',
    img: `${process.env.VUE_APP_PATH}img/fr1.jpg`,
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_do/ro_1phase_277V_${stepGoalTemp}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_277V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues standard Deionized type water heaters set at 120°F, which can be field-adjusted up to 140°F & down to 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    tip: '<b>Note</b>: Eemax does not manufacture Deionized type water heaters that will go beyond 140°F up to 180°F!',
    defaultValue: 120,
    locked: false,
    nextId: `${branchIndustrial}_do/ro_1phase_277V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_do/ro_1phase_277V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },


  // branch Industrial - t180
  {
    id: `${branchIndustrial}_t180_${is3PhasePower}`,
    step: '3-phase power',
    component: 'Selector',
    title: 'Is 3-phase power going to be used?',
    tip: '<b>Note</b>: For higher GPM flow rates (+4 GPM), you will likely need 3-Phase power to facilitate the higher kW necessary to achieve higher temperatures!!',
    options: [
      {
        title: 'Yes',
        value: '1',
        nextId: `${branchIndustrial}_t180_3phase_${stepVoltage}`,
        typeYes: true,
        params: { phase: 3, 'product-family': ['bcbcf016-b763-4453-949e-0ac175ea7a1b', '27ccfe56-9d53-4acf-9cd8-9c80e38fc8a7'] },
      },
      {
        title: 'No',
        value: '0',
        nextId: `${branchIndustrial}_t180_1phase_${stepVoltage}`,
        typeNo: true,
        params: { phase: 1, application: ['industrial', 'washdown-process'], 'max-temp': 180 },
      },
    ],
  },
  // branch Industrial - t180 - 3 phase
  {
    id: `${branchIndustrial}_t180_3phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of 3-Phase voltage for your heater?',
    options: [
      { title: '208 V', params: { 'max-temp': 180, volts: 208 }, nextId: `${branchIndustrial}_t180_3phase_208/480/600V_${stepFlowRate}` },
      { title: '480 V', params: { 'max-temp': 180, volts: 480 }, nextId: `${branchIndustrial}_t180_3phase_208/480/600V_${stepFlowRate}` },
      { title: '600 V', params: { volts: 600 }, nextId: `${branchIndustrial}_t180_3phase_208/480/600V_${stepFlowRate}` },
    ],
  },
  // branch Industrial - t180 - 3 phase - 208V / 480V / 600V
  {
    id: `${branchIndustrial}_t180_3phase_208/480/600V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures that will be serviced should be for the total volume that would be running simultaneously and not the amount of fixtures.',
    defaultValue: 6,
    inputLabel: 'Enter Total Flow Rate (GPM)',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.5 GPM & 20 GPM (ProSeries XTP), or 2.5 GPM & 30 GPM (Spec Advantage). If higher than those respective max flows, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select that flow rate.',
    img: `${process.env.VUE_APP_PATH}img/fr2.jpg`,
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_t180_3phase_208/480/600V_${stepGoalTemp}`,
  },
  {
    id: `${branchIndustrial}_t180_3phase_208/480/600V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues these thermostatically controlled water heaters set at 120°F, which can be field-adjusted up to 180°F & down to just below 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 180,
    locked: false,
    nextId: `${branchIndustrial}_t180_3phase_208/480/600V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_t180_3phase_208/480/600V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - t180 - 1 phase
  {
    id: `${branchIndustrial}_t180_1phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    options: [
      { title: '120 V', value: 120, nextId: `${branchIndustrial}_t180_1phase_120V_${stepFlowRate}` },
      { title: '208 V', value: 208, nextId: `${branchIndustrial}_t180_1phase_208V_${stepFlowRate}` },
      { title: '240 V', value: 240, nextId: `${branchIndustrial}_t180_1phase_240V_${stepFlowRate}` },
      { title: '277 V', value: 277, nextId: `${branchIndustrial}_t180_1phase_277V_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  // branch Industrial - t180 - 1 phase - 120V
  {
    id: `${branchIndustrial}_t180_1phase_120V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_t180_1phase_120V_${stepGoalTemp}`,
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 GPM & 0.4 GPM. If higher than 0.4 GPM, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    fixtures: [
      {
        title: 'High Efficiency Low Flow Sprayer',
        flowRate: '~0.4 GPM',
        flowRateValue: 0.4,
        img: `${process.env.VUE_APP_PATH}/img/HELFS.jpg`,
        quantity: 1,
      },
    ],
  },
  {
    id: `${branchIndustrial}_t180_1phase_120V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues these Sanitation type water heaters set at 120°F, which can be adjusted upwards to 180°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 180,
    locked: false,
    nextId: `${branchIndustrial}_t180_1phase_120V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_t180_1phase_120V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - t180 - 1 phase - 208V
  {
    id: `${branchIndustrial}_t180_1phase_208V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_t180_1phase_208V_${stepGoalTemp}`,
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 GPM & 0.9 GPM (LavAdvantage), or 0.7 GPM & 1.9 GPM (Series 2). If higher than those respective max flows, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    fixtures: [
      {
        title: 'High Efficiency Low Flow Sprayer',
        flowRate: '~0.4 GPM',
        flowRateValue: 0.4,
        img: `${process.env.VUE_APP_PATH}/img/HELFS.jpg`,
        quantity: 1,
      },
      {
        title: 'High Efficiency Spray Hose',
        flowRate: '~1.2 GPM',
        flowRateValue: 1.2,
        img: `${process.env.VUE_APP_PATH}/img/HESH.jpg`,
        quantity: 1,
      },
    ],
  },
  {
    id: `${branchIndustrial}_t180_1phase_208V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues the LavAdvantage -S type water heaters set at 120°F, which can be adjusted upwards to 180°F. Eemax issues the Series 2 models set at 180°F, & can be adjusted down to 140°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 180,
    locked: false,
    nextId: `${branchIndustrial}_t180_1phase_208V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_t180_1phase_208V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - t180 - 1 phase - 240V
  {
    id: `${branchIndustrial}_t180_1phase_240V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_t180_1phase_240V_${stepGoalTemp}`,
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 GPM & 1.3 GPM (LavAdvantage), 0.7 & 3.2 GPM (Series 2 or 3). If higher than those respective max flows, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    fixtures: [
      {
        title: 'High Efficiency Low Flow Sprayer',
        flowRate: '~0.4 GPM',
        flowRateValue: 0.4,
        img: `${process.env.VUE_APP_PATH}/img/HELFS.jpg`,
        quantity: 2,
      },
      {
        title: 'High Efficiency Spray Hose',
        flowRate: '~1.2 GPM',
        flowRateValue: 1.2,
        img: `${process.env.VUE_APP_PATH}/img/HESH.jpg`,
        quantity: 1,
      },
    ],
  },
  {
    id: `${branchIndustrial}_t180_1phase_240V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues the LavAdvantage sanitation type water heaters set at 120°F, which can be adjusted upwards to 180°F. Eemax issues the Series 2 & 3 sanitation type water heaters set at 180°F, & can be adjusted down to 140°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 180,
    locked: false,
    nextId: `${branchIndustrial}_t180_1phase_240V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_t180_1phase_240V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - t180 - 1 phase - 277V
  {
    id: `${branchIndustrial}_t180_1phase_277V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_t180_1phase_277V_${stepGoalTemp}`,
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.2 GPM & 1.1 GPM (LavAdvantage), or 0.7 GPM & 2.25 GPM (Series 2). If higher than those respective max flows, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    fixtures: [
      {
        title: 'High Efficiency Low Flow Sprayer',
        flowRate: '~0.4 GPM',
        flowRateValue: 0.4,
        img: `${process.env.VUE_APP_PATH}/img/HELFS.jpg`,
        quantity: 2,
      },
      {
        title: 'High Efficiency Spray Hose',
        flowRate: '~1.2 GPM',
        flowRateValue: 1.2,
        img: `${process.env.VUE_APP_PATH}/img/HESH.jpg`,
        quantity: 0,
      },
    ],
  },
  {
    id: `${branchIndustrial}_t180_1phase_277V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues the LavAdvantage sanitation type water heaters set at 120°F, which can be adjusted upwards to 180°F. Eemax issues the Series 2 sanitation type water heaters set at 180°F, & can be adjusted down to 140°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 180,
    locked: false,
    nextId: `${branchIndustrial}_t180_1phase_277V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_t180_1phase_277V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },


  // branch Industrial - t100-140
  {
    id: `${branchIndustrial}_t100-140_${is3PhasePower}`,
    step: '3-phase power',
    component: 'Selector',
    title: 'Is 3-phase power going to be used?',
    tip: '<b>Note</b>: For higher GPM flow rates (+4 GPM), you will likely need 3-Phase power to facilitate the higher kW necessary to achieve higher temperatures!!',
    options: [
      {
        title: 'Yes',
        value: '1',
        nextId: `${branchIndustrial}_t100-140_3phase_${stepVoltage}`,
        typeYes: true,
        params: { phase: 3, 'product-family': ['27ccfe56-9d53-4acf-9cd8-9c80e38fc8a7'] },
      },
      {
        title: 'No',
        value: '0',
        nextId: `${branchIndustrial}_t100-140_1phase_${stepVoltage}`,
        typeNo: true,
        params: { phase: 1, 'product-family': ['bb361c6d-b723-4e6a-aff2-96904ff363b9'] },
      },
    ],
  },
  // branch Industrial - t100-140 - 3 phase
  {
    id: `${branchIndustrial}_t100-140_3phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of 3-Phase voltage for your heater?',
    options: [
      { title: '208 V', value: 208, nextId: `${branchIndustrial}_t100-140_3phase_208/480_${stepFlowRate}` },
      { title: '480 V', value: 480, nextId: `${branchIndustrial}_t100-140_3phase_208/480_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  // branch Industrial - t100-140 - 3 phase - 208V / 480V
  {
    id: `${branchIndustrial}_t100-140_3phase_208/480_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures that will be serviced should be for the total volume that would be running simultaneously and not the amount of fixtures.',
    defaultValue: 6,
    inputLabel: 'Enter Total Flow Rate (GPM)',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.5 GPM & 20 GPM. If higher than 20 GPM, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select that flow rate.',
    img: `${process.env.VUE_APP_PATH}img/fr2.jpg`,
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_t100-140_3phase_208/480_${stepGoalTemp}`,
  },
  {
    id: `${branchIndustrial}_t100-140_3phase_208/480_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues ProSeries XTP water heaters set at 120°F, which can be field-adjusted up to 180°F & down to just below 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 120,
    locked: false,
    nextId: `${branchIndustrial}_t100-140_3phase_208/480_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_t100-140_3phase_208/480_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Industrial - t100-140 - 1 phase
  {
    id: `${branchIndustrial}_t100-140_1phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    options: [
      { title: '208 V', value: 208, nextId: `${branchIndustrial}_t100-140_1phase_208V/240V_${stepFlowRate}` },
      { title: '240 V', value: 240, nextId: `${branchIndustrial}_t100-140_1phase_208V/240V_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  // branch Industrial - t180 - 1 phase - 208V / 240V
  {
    id: `${branchIndustrial}_t100-140_1phase_208V/240V_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixture(s) it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’) from the unit. Select your local fixture flow rate.',
    paramName: 'max-flow',
    nextId: `${branchIndustrial}_t100-140_1phase_208V/240V_${stepGoalTemp}`,
    title: 'What is the simultaneous flow rate that the unit will need to heat?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'Depending on your need, the flow rate in GPM listed below should be in between 0.3 & 6 GPM. If higher than 6 GPM, then you may need an additional unit or <a href="#" class="e-assistance">assistance in your selection</a>.',
    fixtures: [
      {
        title: 'High Efficiency Low Flow Sprayer',
        flowRate: '~0.4 GPM',
        flowRateValue: 0.4,
        img: `${process.env.VUE_APP_PATH}/img/HELFS.jpg`,
        quantity: 1,
      },
      {
        title: 'High Efficiency Spray Hose',
        flowRate: '~1.2 GPM',
        flowRateValue: 1.2,
        img: `${process.env.VUE_APP_PATH}/img/HESH.jpg`,
        quantity: 3,
      },
    ],
  },
  {
    id: `${branchIndustrial}_t100-140_1phase_208V/240V_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues ProSeries water heaters set at 120°F. The 8 – 13 kW models can be internally field-adjusted up to 140°F & down to just below 100°F. The 18 – 36 kW units can be internally field-adjusted up to 180°F & down to just below 100°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 120,
    locked: false,
    nextId: `${branchIndustrial}_t100-140_1phase_208V/240V_${stepResult}`,
  },
  {
    id: `${branchIndustrial}_t100-140_1phase_208V/240V_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
];
